import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { graphql } from 'gatsby';
import moment from 'moment';

import Press from '../../layouts/PressLayout';
import { ActionCard, Data } from '../../components';
import placeholder from '../../assets/media/logo-mascot.svg';

const PressAbout = props => {
  const {
    data: {
      pageData: { childDataYaml: pageData },
      allPress: { edges: pressData },
    },
  } = props;

  const getFeaturedPress = () => {
    // Get node data out of press query
    const press = pressData.reduce(
      (accumulator, currentValue) => accumulator.concat(currentValue.node),
      []
    );
    // Grab only interior link from featured press data
    const featuredPress = pageData.featuredPress.items.reduce(
      (accumulator, currentValue) => accumulator.concat(currentValue.link),
      []
    );
    const matchedPress = [];

    // Attempt to match featured press item (from yaml data) against queried data and return full node
    press.map(pressItem => {
      if (featuredPress.includes(pressItem.frontmatter.link)) {
        matchedPress.push(pressItem);
      }

      return false;
    });

    return matchedPress;
  };

  const renderPressItem = node => {
    const mediaLogo = node.frontmatter.logo || placeholder;

    return (
      <li key={node.fileAbsolutePath}>
        <ActionCard
          photo={mediaLogo}
          hover
          target="_blank"
          rel="noopener noreferrer"
          url={node.frontmatter.link}
        >
          <Data>{node.frontmatter.title}</Data>
        </ActionCard>
      </li>
    );
  };

  return (
    <Press>
      <Helmet
        title={pageData.title}
        meta={[{ name: 'description', content: pageData.description }]}
      />
      <section className="section section--large">
        <div className="container">
          <div className="section-titleWrapper">
            <h3 className="section-title">
              <Data>{pageData.section1.heading}</Data>
            </h3>
            <div className="section-titleSub">
              <Data markdown>{pageData.section1.blurb}</Data>
            </div>
          </div>
        </div>
      </section>
      {getFeaturedPress().length ? (
        <section className="section section--large section--slant section--shadow u-bgPanel">
          <div className="container">
            <div className="section-titleWrapper section-titleWrapper--forceLeft@medium">
              <h3 className="section-title">
                <Data>{pageData.featuredPress.heading}</Data>
              </h3>
            </div>
            <ul className="blockGrid blockGrid-2@small blockGrid-3@medium blockGrid--largeGutter blockGrid--deepMatch">
              {getFeaturedPress().map(featuredPressItem =>
                renderPressItem(featuredPressItem)
              )}
            </ul>
          </div>
        </section>
      ) : null}
      <section className="section section--large">
        <div className="container">
          <div className="section-titleWrapper">
            <h3 className="section-title">
              <Data>{pageData.timeline.heading}</Data>
            </h3>
          </div>
          <div className="row u-flexCenter">
            <div className="column-9@medium">
              <ol className="u-list press__timeline">
                {pageData.timeline.items.map(event => (
                  <li
                    key={event.date}
                    data-year={moment(event.date).format('YYYY')}
                  >
                    <div>
                      <Data markdown>{event.blurb}</Data>
                      <time dateTime={moment(event.date).format('YYYY-MM')}>
                        {moment(event.date).format('MMMM')}
                      </time>
                    </div>
                  </li>
                ))}
              </ol>
            </div>
          </div>
        </div>
      </section>
    </Press>
  );
};

PressAbout.propTypes = {
  data: PropTypes.object.isRequired,
};

export default PressAbout;

export const pageQuery = graphql`
  query PressAboutPageData {
    pageData: file(name: { eq: "press__about" }) {
      childDataYaml {
        title
        description
        section1 {
          blurb
          heading
        }
        featuredPress {
          heading
          items {
            link
          }
        }
        timeline {
          heading
          items {
            blurb
            date
          }
        }
      }
    }

    allPress: allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: {
        fileAbsolutePath: { regex: "/src/media/" }
        frontmatter: { title: { ne: "BLUEPRINT" } }
      }
    ) {
      edges {
        node {
          ...MediaFragment
        }
      }
    }
  }
`;
